import React__default, { Component } from 'react';
import { __extends } from '../../_virtual/_tslib.js';
import styles from './styles.css.js';

var TypingIndicator =
/** @class */
function (_super) {
  __extends(TypingIndicator, _super);

  function TypingIndicator() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  TypingIndicator.prototype.render = function () {
    var typing = this.props.typing;
    var names = typing.map(function (identity) {
      return identity.displayName;
    });
    var activity;

    switch (names.length) {
      case 0:
        activity = null;
        break;

      case 1:
        activity = names[0] + " is typing...";
        break;

      case 2:
      case 3:
        activity = names.slice(0, -1).join(', ') + " and " + names.slice(1)[0] + " are typing...";
        break;

      default:
        activity = names.length + " people are typing...";
    }

    if (activity) {
      return React__default.createElement("div", {
        className: styles.row
      }, React__default.createElement("div", {
        className: styles.typing
      }, React__default.createElement("div", {
        className: styles.dot
      }), React__default.createElement("div", {
        className: styles.dot
      }), React__default.createElement("div", {
        className: styles.dot
      })), activity);
    } else {
      return null;
    }
  };

  return TypingIndicator;
}(Component);

export default TypingIndicator;
//# sourceMappingURL=index.js.map
